import React from 'react'

class Background extends React.Component {
	render() {
		return (
			<div>
				<div className="circle one">&nbsp;</div>
				<div className="circle three">&nbsp;</div>
				<div className="circle four">&nbsp;</div>
				<div className="circle five">&nbsp;</div>
				<div className="circle six">&nbsp;</div>
				<div className="circle seven">&nbsp;</div>
				<div className="circle eight">&nbsp;</div>
				<div className="circle nine">&nbsp;</div>
				<div className="circle ten">&nbsp;</div>
				<div className="circle eleven">&nbsp;</div>
				<div className="circle twelve">&nbsp;</div>
				<div className="circle thirteen">&nbsp;</div>
				<div className="circle fourteen">&nbsp;</div>
			</div>
		)
	}
}

export default Background


// WEBPACK FOOTER //
// ./src/App/components/background.js